 /* globals urls, RSVP, triggerTabClickByHash */

var $ = jQuery.noConflict();
window.CourseNav = function(currentPostId){
	this.RSVP = RSVP;
	this.navSelectors = {
		core: 'nav.side-nav.course-template-post-side-nav .kois-courses-menu-item',
		virtual: 'nav.side-nav.course-template-post-side-nav .virtual-courses-menu-item',
		adjunct: 'nav.side-nav.course-template-post-side-nav .adjunct-courses-menu-item'
	};
	this.currentPostId = currentPostId;
};

// Requests course navigation markup from the server
CourseNav.prototype.requestNavigation = function(){
	var self = this;
	return new this.RSVP.Promise(function( resolve, reject ){
		if( !self.pageHasParentNavItems() ){
			reject( 'Page doesn\'t have target parent nav items, aborting async load of course navigation items' );
		}
		
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'fetch_course_nav_markup',
				currentPostId: self.currentPostId
			}
		})
		.done(function( res ) {
			if( res ){
				resolve( res );
			}
			reject( 'An error occurred while fetching course navigation items' );
		});
	});
};

// Checks if the page has at least 1 parent nav items for the data being requested
CourseNav.prototype.pageHasParentNavItems = function(){
	return $([this.navSelectors.core, this.navSelectors.virtual, this.navSelectors.adjunct].join(', ')).length > 0;
};

// Gets navigation markup
CourseNav.prototype.getNavigation = function(){
	var self = this;
	var result = this.requestNavigation();
	
	result.then(function(navigationMarkup){
		self.insertNavigationMarkup(navigationMarkup);
	}).catch(function(err){
		self.handleError(err);
	});
};

CourseNav.prototype.insertNavigationMarkup = function(navigationMarkup){
	//console.log('Initializing course navigation markup');
	var self = this;
	
	if(navigationMarkup.hasOwnProperty('core')){
		$(self.navSelectors.core).append(navigationMarkup.core);
	}

	if(navigationMarkup.hasOwnProperty('virtual')){
		$(self.navSelectors.virtual).append(navigationMarkup.virtual);
	}
	
	if(navigationMarkup.hasOwnProperty('adjunct')){
		$(self.navSelectors.adjunct).append(navigationMarkup.adjunct);
	}

	$([self.navSelectors.core, self.navSelectors.virtual, self.navSelectors.adjunct].join(', ')).removeClass('loading');
};

CourseNav.prototype.handleError = function(err){
	console.log('Error loading course navigation data', err);
	var self = this;
	
	$([self.navSelectors.core, self.navSelectors.virtual, self.navSelectors.adjunct].join(', ')).removeClass('loading');
};

// Special case for a click event on the kois or adjunct menu item while on that page
$('.kois-courses-menu-item.current-menu-item > a, .virtual-courses-menu-item.current-menu-item > a, .adjunct-courses-menu-item.current-menu-item > a').click(function(e){
	e.preventDefault();
	var possibleTabHash = e.target.hash.substring(1);
	triggerTabClickByHash(possibleTabHash);
	console.log(e);
});